// in gastby-browser.js
exports.shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  window.scrollTo(0, 0); // Scroll top when user change page
  return false;
};
